import { z } from 'zod';

/**
 * Step 4 — Parâmetros (RD Equipamentos, ramo 0171): condições comerciais
 * (comissão/fator de desconto-agravo) e pagamento (parcelas/primeira
 * parcela).
 *
 * Espelha `RdParamsPayload` (`@/services/quotes/rd-equipamentos/types`)
 * campo a campo — valores já NORMALIZADOS (`commission`/`discountFactor` em
 * micro, `installments` inteiro). Os TETOS comerciais (`maxCommission`/
 * `maxAdjustFactor`, de `useRdCommercialRule()`) só existem em
 * runtime (via query), então NÃO entram aqui — são aplicados nos
 * validadores de campo do componente (`step-parametros.component.tsx`),
 * não neste schema estático.
 */
export const StepParametrosSchema = z.object({
  commission: z.number().int().nonnegative('Informe a comissão'),
  discountFactor: z
    .number()
    .int()
    .nonnegative('Informe o fator de desconto/agravo'),
  installments: z.number().int().min(1, 'Selecione o número de parcelas'),
  firstInstallment: z.enum(['cash', '30d'], {
    message: 'Selecione a primeira parcela',
  }),
  /**
   * `code` de `RdPaymentMethod` (catálogo do i4pro via
   * `useRdPaymentMethods()`). Opcional: proposta sem forma escolhida é
   * válida, e o Motor resolve na emissão. Responde COMO se paga — não
   * confundir com `firstInstallment` (QUANDO vence a primeira parcela).
   */
  paymentMethod: z.number().int().positive().optional(),
});

/** Formato normalizado (payload-ready) — ver nota acima. */
export type StepParametrosValues = z.infer<typeof StepParametrosSchema>;

/**
 * Formato bruto do formulário — `commission`/`discountFactor` ficam como
 * string mascarada (display pt-BR, ex.: '0,60' / '1,15') e `installments`
 * como string (valor do `SelectField`); só são convertidos para
 * `StepParametrosValues` no submit (ver `use-set-rd-params.hook.ts`).
 */
export type StepParametrosFormValues = {
  commission: string;
  discountFactor: string;
  installments: string;
  firstInstallment: string;
  paymentMethod: string;
};
